export default __webpack_public_path__ + "static/media/mo.9ef2ce6f.svg";